class ScaleBackground {
	constructor(scale) {
		this._scale = scale;
		this._marks = [];
		this._elem = UI.div('scaleBackground');
	}

	get firstMark() {return this._marks[0];}
	get lastMark() {return this._marks[this._marks.length -1];}

	init() {
		let seed = new ScaleBgMark(this);
		seed.findMajor();
		this._marks.push(seed);
	}

	scaleChange(){
		this._marks[0].findMajor();
		for(let a = 1, aa = this._marks.length; a < aa; a++) {
			this._marks[a].time = this._marks[a-1].time + this._scale.major;
		}
	}

	update() {
		while (this.lastMark.time < this._scale.end) this._marks.push(ScaleBgMark.after(this, this.lastMark));
		while (this._scale.start < this.firstMark.time) this._marks.unshift(ScaleBgMark.before(this, this.firstMark));

		while (this._scale.end < this.lastMark.time && 1 < this._marks.length) this._marks.pop().dispose();
		while (this.firstMark.time < this._scale.start && 1 < this._marks.length) this._marks.shift().dispose();

		this._marks.forEach((mark) => mark.move());
	}
}
